// extracted by mini-css-extract-plugin
export default {"button":"SupportFeedbackButton_button__TBnyc"};